import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full bg-background min-h-screen" }
const _hoisted_2 = { class: "flex flex-row container justify-center space-x-8 py-8" }
const _hoisted_3 = {
  key: 2,
  class: "card-main w-full rounded-2xl"
}
const _hoisted_4 = { class: "flex flex-row justify-between w-full items-center" }
const _hoisted_5 = { class: "flex flex-row items-center space-x-3" }
const _hoisted_6 = { class: "text-2xl font-semibold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M7 16l-4-4m0 0l4-4m-4 4h18"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ErrorPage = _resolveComponent("ErrorPage")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_ClientInformation = _resolveComponent("ClientInformation")!
  const _component_MembersTable = _resolveComponent("MembersTable")!
  const _component_InternalsTable = _resolveComponent("InternalsTable")!
  const _component_RolesTable = _resolveComponent("RolesTable")!
  const _component_PaymentContacts = _resolveComponent("PaymentContacts")!
  const _component_CompanyJobBoard = _resolveComponent("CompanyJobBoard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_Loading, {
              key: 0,
              active: _ctx.loading,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
              "can-cancel": false,
              loader: "spinner",
              color: "#8908F9",
              width: 128,
              height: 128,
              opacity: 0.5,
              "is-full-page": true
            }, null, 8, ["active", "opacity"]))
          : _createCommentVNode("", true),
        (_ctx.error && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ErrorPage, { key: 1 }))
          : _createCommentVNode("", true),
        (!_ctx.loading && !_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Avatar, {
                    name: _ctx.data?.name,
                    size: "xl"
                  }, null, 8, ["name"]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.data?.name), 1)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Link, {
                    to: "/clients",
                    variant: "",
                    label: "Return to clients"
                  }, {
                    startIcon: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_component_Tabs, {
                elements: _ctx.tabElements,
                modelValue: _ctx.tab,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
              }, null, 8, ["elements", "modelValue"]),
              (_ctx.tab === 0)
                ? (_openBlock(), _createBlock(_component_ClientInformation, {
                    key: 0,
                    data: _ctx.data
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true),
              (_ctx.tab === 1)
                ? (_openBlock(), _createBlock(_component_MembersTable, {
                    key: 1,
                    company: _ctx.company
                  }, null, 8, ["company"]))
                : _createCommentVNode("", true),
              (_ctx.tab === 2)
                ? (_openBlock(), _createBlock(_component_InternalsTable, { key: 2 }))
                : _createCommentVNode("", true),
              (_ctx.tab === 3)
                ? (_openBlock(), _createBlock(_component_RolesTable, {
                    key: 3,
                    company_id: _ctx.company_id
                  }, null, 8, ["company_id"]))
                : _createCommentVNode("", true),
              (_ctx.tab === 4)
                ? (_openBlock(), _createBlock(_component_PaymentContacts, {
                    key: 4,
                    company_id: _ctx.company_id,
                    payment_contacts: _ctx.company.payment_contacts,
                    default_contact: _ctx.company.default_payment_contact,
                    default_email: _ctx.company.owner.email
                  }, null, 8, ["company_id", "payment_contacts", "default_contact", "default_email"]))
                : _createCommentVNode("", true),
              (_ctx.tab === 5)
                ? (_openBlock(), _createBlock(_component_CompanyJobBoard, {
                    key: 5,
                    companyId: _ctx.company_id
                  }, null, 8, ["companyId"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}